import { render, staticRenderFns } from "./detail_novelty_page.vue?vue&type=template&id=209f4b34&scoped=true"
import script from "./detail_novelty_page.vue?vue&type=script&lang=js"
export * from "./detail_novelty_page.vue?vue&type=script&lang=js"
import style0 from "./detail_novelty_page.vue?vue&type=style&index=0&id=209f4b34&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209f4b34",
  null
  
)

export default component.exports